import { A } from "@solidjs/router";
import { Show, Component, onMount } from "solid-js";
import { Img } from "./universal/image";
import { UserSession, FacultyMember } from "../types";
import { createStore } from "solid-js/store";
import { Button } from "solid-bootstrap";
import { CMS } from "./cms/cms";
import { getPlainText, loadCms } from "../app";

type Props = {
    session: UserSession;
    facultyMember: FacultyMember;
    resources: {
        canApply: boolean;
    };
    deleteClicked: (id: string) => void;
};

export const FacultyMemberItem : Component<Props> = (props) => {
    const canApply: boolean = props.resources.canApply;
    const [facultyMember, setFacultyMember] = createStore<FacultyMember>(props.facultyMember);
    const deleteFacultyMemberClicked = (facultyMember: FacultyMember) =>{
        console.log("deleteFacultyMemberClicked", { facultyMember });
        if (confirm(getPlainText("dialog::sure-you-wish-to-delete-this-entry", "Are you sure you wish to delete this entry?"))) {
            props.deleteClicked(facultyMember.Id);
        }
    };
    onMount(async () => {
        const ids=[
            "label::medium","label::purchase-award-nominated-price","label::size","label::completed-in","label::location","label::about-this-artwork",
            "label::categories","label::images",
            "salon-application/step-2::salon-artwork/file-details",
            "button::view","button::edit","button::delete","button::add",
            "button::remove",
            "error::category/unable-to-enter","error::category/select-from-list",
            "dialog::sure-you-wish-to-delete-this-image","dialog::sure-you-wish-to-delete-this-entry",
            "error::category/unable-to-remove-artwork","error::category/unable-to-enter"
        ];
        await loadCms(ids);
    });
    return (
        <div class="artwork-container" style="padding: 10px 20px;">
            <h3>
                {facultyMember.FirstName} {facultyMember.LastName}
            </h3>
            <div>
                {facultyMember.Position}
            </div>
            <div style="background-color: #000; padding: 10px; margin-top: 20px;">
                <A href={ `/edit-faculty-member/${facultyMember.Id}` }>
                    <Img src={ facultyMember.Photo?.URL } mode="crop" width={300} format="jpg" style="width: 100%;" />
                </A>
            </div>
            <div style="margin-top: 20px;">
                <Show when={canApply}>
                    <div style="float: right;">
                        <A class="btn btn-primary" style="margin-right: 5px;" href={ "/edit-faculty-member/" + facultyMember.Id }>Edit</A>
                        <button class="btn btn-danger" type="button" onClick={(e) => { e.preventDefault(); deleteFacultyMemberClicked(facultyMember); }}>Delete</button>
                    </div>
                </Show>
            </div>
        </div>
    );
}